import { createContext } from 'react';

const initialContext = [{}, () => {}];
export const dataStore = createContext(initialContext);
export default dataStore.Provider;
